import { SelfServicesData } from '../data/self-services'
import { VideoFigure } from '~/components-v2/figure/video-figure'
import { useState } from 'react'

interface SelfServicesProps {
  data?: typeof SelfServicesData
}

const getAutoplayUrl = (url: string) => {
  const urlObject = new URL(url)
  urlObject.searchParams.set('autoplay', '1')

  return urlObject.toString()
}

const CustomerVideoCard = ({
  posterSrc,
  title,
  videoUrl,
}: {
  posterSrc: string
  title: string
  videoUrl: string
}) => {
  const [isPlaying, setIsPlaying] = useState(false)

  return (
    <div className="customer-video-card">
      {isPlaying ? (
        <VideoFigure src={getAutoplayUrl(videoUrl)} title={title} />
      ) : (
        <button
          aria-label={`Play ${title} customer story`}
          className="customer-video-card__poster"
          onClick={() => setIsPlaying(true)}
          type="button"
        >
          <img
            alt=""
            className="customer-video-card__image"
            loading="lazy"
            src={posterSrc}
          />
        </button>
      )}
    </div>
  )
}

export const SelfServices = ({
  data = SelfServicesData,
}: SelfServicesProps) => {
  return (
    <div className="self-services">
      {data &&
        data.map((service, index) => {
          const { title, description, logoSrc, posterSrc, videoUrl } = service

          return (
            <article
              key={`service-${index}`}
              className={`service ${index % 2 === 1 ? ' reverse' : ''}`}
            >
              <CustomerVideoCard
                posterSrc={posterSrc}
                title={title}
                videoUrl={videoUrl}
              />

              <div className="customer-story-copy">
                <img
                  src={logoSrc}
                  alt={title}
                  className={`customer-story-logo ${title
                    .toLowerCase()
                    .replace(/\s+/g, '-')}`}
                />
                <p className="body-l text-primary">{description}</p>
              </div>
            </article>
          )
        })}
    </div>
  )
}
